import * as React from 'react';

import AkCrossCircleIcon from '@atlaskit/icon/core/cross-circle';
import AkErrorIcon from '@atlaskit/icon/core/status-error';
import AkInfoIcon from '@atlaskit/icon/core/status-information';
import AKCheckCircleIcon from '@atlaskit/icon/core/status-success';
import AkWarningIcon from '@atlaskit/icon/core/status-warning';
import { token } from '@atlaskit/tokens';

export const createErrorIcon = () =>
  React.createElement(AkWarningIcon, {
    label: '',
    color: token('color.icon.warning', '#E56910'),
  });
export const createDangerIcon = () =>
  React.createElement(AkWarningIcon, {
    label: '',
    color: token('color.icon.accent.red', '#C9372C'),
  });
export const createRhombusErrorIcon = () =>
  React.createElement(AkErrorIcon, {
    label: '',
    color: token('color.icon.danger', '#C9372C'),
    testId: 'adminhub-error-package-rombus-error-icon',
  });
export const createSuccessIcon = () =>
  React.createElement(AKCheckCircleIcon, {
    label: '',
    color: token('color.icon.success', '#22A06B'),
    testId: 'adminhub-error-package-success-icon',
  });
export const createErrorCrossIcon = () =>
  React.createElement(AkCrossCircleIcon, {
    label: '',
    color: token('color.icon.accent.red', '#C9372C'),
  });
export const createInfoIcon = () =>
  React.createElement(AkInfoIcon, {
    label: '',
    color: token('color.icon.brand', '#0C66E4'),
  });
